import { hexToRgb } from '@website/common/utils'
export default {
  DARK: {
    border: () => 'none',
    shadow: () => 'none',
    buttonShadow: () => 'none',
    raisedShadow: () => 'none',
    heading: p => p.primaryLight,
    paragraph: p => p.accentWhite,
    blockTitle: p => p.accentWhite,
    background: p => p.tertiaryDark,
    anchor: p => p.primaryDark,
    backgroundDark: p => `rgba(${hexToRgb(p.primaryLight)}, 0.6)`
  },
  LIGHT: {
    heading: p => p.primaryDark,
    paragraph: p => p.tertiaryNormal,
    blockTitle: p => p.accentWhite,
    background: p => p.tertiaryLight,
    anchor: p => p.primaryDark,
    backgroundDark: p => `rgba(${hexToRgb(p.primaryDark)}, 0.6)`
  },
  EXTRALIGHT: {
    heading: p => p.primaryDark,
    paragraph: p => p.tertiaryNormal,
    blockTitle: p => p.accentWhite,
    background: p => p.tertiaryExtraLight,
    anchor: p => p.primaryDark,
    backgroundDark: p => `rgba(${hexToRgb(p.primaryDark)}, 0.6)`
  }
}
